import React from "react";
import { X } from "lucide-react";
import PublicContentCard from "./PublicContentCard";

/*
 * Preview modal — reuses the exact PublicContentCard component so admin sees
 * the same rendering that will appear on the public site (WYSIWYG parity).
 */
export default function CMSPreviewModal({ open, content, onClose }) {
  if (!open || !content) return null;
  return (
    <div
      className="fixed inset-0 z-50"
      onClick={onClose}
      data-testid="cms-preview-modal"
    >
      <div className="absolute inset-0 bg-black/50" />
      <div className="relative h-full w-full flex items-center justify-center p-4">
        <div
          className="bg-[#F8F9FA] rounded-lg shadow-2xl w-full max-w-3xl max-h-[90vh] flex flex-col"
          onClick={(e) => e.stopPropagation()}
        >
          <header className="flex items-center justify-between px-5 py-3 border-b border-[#E2E8F0] bg-white rounded-t-lg">
            <div>
              <div className="text-[11px] uppercase tracking-wider text-[#64748B]">
                Preview — {content.status}
              </div>
              <div className="text-sm font-semibold text-[#0F172A]">
                Public rendering
              </div>
            </div>
            <button
              onClick={onClose}
              className="h-9 w-9 rounded-md hover:bg-[#F1F5F9] inline-flex items-center justify-center"
              data-testid="cms-preview-close"
              aria-label="Close preview"
            >
              <X className="h-4 w-4" />
            </button>
          </header>
          <div className="flex-1 overflow-y-auto p-5">
            <PublicContentCard content={content} preview />
          </div>
        </div>
      </div>
    </div>
  );
}
